<template>
  <div class="qrcode-content">
    <div
      v-if="!session.isQRCodeLoaded && !session.qrCodeError"
      class="qrcode-loading"
    >
      <div class="qrcode-spinner"></div>
      <p>QRコードを読み込み中...</p>
    </div>
    <div v-if="session.qrCodeError" class="qrcode-error">
      <p>読み込みに失敗しました</p>
      <el-button type="text" @click="retryQRCode">再読み込み</el-button>
    </div>
    <div v-if="session.isPrePayment" class="qrcode-container">
      <h3>ファミリーマート・ローソン・ミニストップ・ポプラ</h3>
      <img
        v-show="session.isQRCodeLoaded && !session.qrCodeError"
        class="eprint_qrcode"
        :src="qrCodeImageSrc"
        @load="onQRCodeLoad"
        @error="onQRCodeError"
      />
    </div>
    <div
      v-else
      :class="{
        'qrcode-container': session.selectedStore,
        'qrcode-message': !session.selectedStore
      }"
    >
      <img
        v-show="session.isQRCodeLoaded && !session.qrCodeError"
        class="eprint_qrcode"
        :class="{ sample: !session.selectedStore }"
        :src="qrCodeImageSrc"
        @load="onQRCodeLoad"
        @error="onQRCodeError"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useTimeoutFn } from '@vueuse/core'
import { useEprintSession } from '@/composables/format-edit/useEprintSession'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { buildEprintQrUrl } from '@/utils/format-edit/eprintQrUrl'

const session = useEprintSession()
const { varuna } = useHostServices()

const qrCodeImageSrc = computed(() =>
  buildEprintQrUrl({
    endpoint: varuna.endPoints.getEprintQrcode,
    contentsCode: session.eprintContentsCode,
    cacheBuster: session.qrCodeCacheBuster,
    isPrePayment: session.isPrePayment,
    selectedStore: session.selectedStore
  })
)

function forceReloadQRCode() {
  session.qrCodeCacheBuster = Date.now()
  session.isQRCodeLoaded = false
}

const retryTimer = useTimeoutFn(
  () => {
    forceReloadQRCode()
  },
  2000,
  { immediate: false }
)

function onQRCodeLoad() {
  session.isQRCodeLoaded = true
  session.qrCodeError = false
  session.qrCodeRetryCount = 0
}

function onQRCodeError() {
  session.qrCodeRetryCount++
  if (session.qrCodeRetryCount < 3) {
    retryTimer.start()
  } else {
    session.qrCodeError = true
    session.isQRCodeLoaded = true
  }
}

function retryQRCode() {
  session.qrCodeError = false
  session.isQRCodeLoaded = false
  session.qrCodeRetryCount = 0
  forceReloadQRCode()
}
</script>
